<div class="snack-wrapper">
  <span class="message">{{ data.message() }}</span>

  <button mat-button color="accent" (click)="snackBarRef.dismiss()">Chiudi</button>
</div>
